import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B04InventoryManagementPage } from '../b04-inventory-management/b04-inventory-management';
import { B04cInventoryPage } from '../b04c-inventory/b04c-inventory';

/**
 * Generated class for the B04bInventoryAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface inventoryTypeInfo{
  INVENTORY_TYPE_ID: number;
  NAME: string;
}
interface branchInfo{
  BRANCH_ID: string;
  BRANCH_NAME: string;
  BRANCH_ACTIVE: string;  
}
@IonicPage()
@Component({
  selector: 'page-b04b-inventory-add',
  templateUrl: 'b04b-inventory-add.html',
})
export class B04bInventoryAddPage {

  private todo : FormGroup;
  inventoryTypeArr: inventoryTypeInfo[] = [];
  inventoryTypeItems: inventoryTypeInfo[] = [];
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  loading: any;
  Status: any;
  mybranchid:any;
  mybranchname:any
  public errorMessage: any = "";
  BRANCH_ID:any;
  inventoryData = { BRANCH_ID:'', INVENTORY_TYPE_ID:'',
                    ITEM_DESC:'',  COST:'',
                    SELLING_PRICE:'', INVENTORY_ACTIVE:'YES',
  }

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
              public loadingCtrl: LoadingController) {
    this.mybranchid = sessionStorage.getItem('userbranchid');
    if(this.mybranchid == "null")
    {
      this.todo = this.formBuilder.group({
        branch: ['', Validators.required],
        itemDesc: ['', Validators.required],
        cost: ['', Validators.required],
        sellingPrice: ['', Validators.required],
        inventoryType: ['', Validators.required],
        inventoryActive: ['', Validators.required],
      });
    }
    else
    {
      this.todo = this.formBuilder.group({
        branch: [''],
        itemDesc: ['', Validators.required],
        cost: ['', Validators.required],
        sellingPrice: ['', Validators.required],
        inventoryType: ['', Validators.required],
        inventoryActive: ['', Validators.required],
      });
      this.inventoryData.BRANCH_ID = this.mybranchid;
    }


    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];
  
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"INVENTORY_TYPE","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
          let Records = result["Records"];
          this.inventoryTypeArr = Records;
          this.inventoryTypeItems = this.inventoryTypeArr;
          
          console.log(this.mybranchid);
          if(this.mybranchid != "null")
          {
            //this.report_request.Data.BRANCH_ID = this.mybranchid;
            let tbl = ["BRANCH"];
            let column = ["BRANCH_ID"];
            let value = [this.mybranchid];
            
            let tblkey = ["No"];
            let fktbl = ["No"];
            let fkkey = ["No"];

            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");
          

            this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
              
              this.Status = result["Message"];
            
              if (this.Status == '1'){
                let Records = result["Records"];
                this.mybranchname = Records[0]["BRANCH_NAME"];
              }
              else {
              
              }
            }, (err) => {
            
          
            });        
          } 
          else
          {
            let tbl = ["All"];
            let column = ["All"];
            let value = ["All"];
            
            let tblkey = ["No"];
            let fktbl = ["No"];
            let fkkey = ["No"];

            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");
           
            this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
              
              this.Status = result["Message"];
              if (this.Status == '1'){
                
                let Records = result["Records"];
                this.branchArr = Records;
                this.branchItems = this.branchArr;
              }
            }, (err) => {
            
          
            });      
          }
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });

    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B04bInventoryAddPage');
  }
  onSelectBranch(data)
  {
   if(data != "All")
   {
    let val = this.branchItems.find(c => c.BRANCH_ID === data);
    this.inventoryData.BRANCH_ID = val["BRANCH_ID"];
   
   }
   else
   {
    this.inventoryData.BRANCH_ID ="All";
   }
  }  
  saveNew(){
    this.showLoader();
    console.log(this.inventoryData);

    this.serviceapi.insertdata("INVENTORY",this.inventoryData).then((result) => {
      console.log(result);
      this.Status = result["Message"];

      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B04cInventoryPage);
      }
      else{
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
    
  }

  cancel(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B04InventoryManagementPage);
  }

  goTo2(){
    this.navCtrl.setRoot(B04cInventoryPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b04b-inventory-add/b04b-inventory-add.ts